import { computed, ref } from '@vue/composition-api'
import { getEnvOptional } from '../utils/runtime-settings.js'

/**
 * Open/close singleton for the floating help-assistant launcher (AB#26561 Task 9), following the
 * same composition-api ref-singleton shape as `shared/state/snackbar.js`. A singleton (rather than
 * component-local state) lets both the launcher itself and the splash-page "Help Assistant"
 * overview card drive the same sheet without prop drilling or an event bus.
 */
export const helpAssistantOpen = ref(false)

/**
 * True once VUE_APP_BASE_URL_PLATFORMAGENT has a value in the loaded runtime settings (AB#26561
 * PR #2723 review). The gate itself (`enableHelpAssistant`) is a config-key feature flag that
 * says nothing about whether the agent's base URL is actually configured for this environment -
 * without this, a tenant with the flag on but no base URL got a FAB/splash card that opened an
 * empty, permanently-unready sheet (help-assistant-panel.vue's own `ready` guard renders
 * nothing). Consumers should gate the FAB and splash card on this AND `enableHelpAssistant`; the
 * panel's `ready` guard stays in place as defense in depth.
 */
export const helpAssistantConfigured = computed(() => getEnvOptional('VUE_APP_BASE_URL_PLATFORMAGENT') !== '')

export const openHelpAssistant = () => {
	helpAssistantOpen.value = true
}

export const closeHelpAssistant = () => {
	helpAssistantOpen.value = false
}
